import { render, staticRenderFns } from "./TaskCommentComposer.vue?vue&type=template&id=3eb98c3c"
import script from "./TaskCommentComposer.vue?vue&type=script&lang=js"
export * from "./TaskCommentComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports